import api from '../utils/api';
import { ICategory } from './StateRequirements';

export const createCategory = async (categoryData: Partial<ICategory>): Promise<ICategory> => {
  const res = await api.post('/api/categories', categoryData);
  return res.data;
};

export const getAllCategories = async (): Promise<ICategory[]> => {
  const res = await api.get('/api/categories');
  return res.data;
};

export const getCategoryById = async (id: string): Promise<ICategory> => {
  const res = await api.get(`/api/categories/${id}`);
  return res.data;
};

export const updateCategory = async (id: string, categoryData: Partial<ICategory>): Promise<ICategory> => {
  const res = await api.put(`/api/categories/${id}`, categoryData);
  return res.data;
};

export const deleteCategory = async (id: string): Promise<void> => {
  await api.delete(`/api/categories/${id}`);
};
